export const jobsData = [
  {
    id: 'PROTOCOL-001',
    title: 'Senior AI Engineer',
    department: 'Synthetic Intelligence',
    location: 'Remote / HQ',
    type: 'Full-time',
    experience: '5+ years',
    salary: 'Competitive + Equity',
    status: 'open',
    description: 'Build Generative AI models that solve complex business equations. Python/TensorFlow mastery required.',
    requirements: [
      'Expert in Python, TensorFlow, PyTorch',
      'Experience with Large Language Models',
      'Strong background in ML/DL algorithms',
      'Experience with cloud AI services',
      'Published research or open-source contributions'
    ],
    responsibilities: [
      'Design and implement AI solutions',
      'Train and fine-tune models on proprietary data',
      'Optimize AI systems for production',
      'Collaborate with product teams',
      'Stay updated with latest AI research'
    ],
    posted: '2024-01-15',
    deadline: '2024-02-28'
  },
  {
    id: 'PROTOCOL-002',
    title: 'Full-Stack Architect',
    department: 'Digital Cortex',
    location: 'HQ',
    type: 'Full-time',
    experience: '7+ years',
    salary: '$120k - $180k',
    status: 'open',
    description: 'Construct scalable ecosystems using MERN/Next.js. Must understand system design at a molecular level.',
    requirements: [
      'Expert in React, Node.js, TypeScript',
      'Experience with microservices architecture',
      'Strong database design skills',
      'AWS/Azure/GCP certification',
      'Experience with DevOps practices'
    ],
    responsibilities: [
      'Design system architecture',
      'Lead development teams',
      'Code review and mentorship',
      'Performance optimization',
      'Technical documentation'
    ],
    posted: '2024-01-10',
    deadline: '2024-02-25'
  },
  {
    id: 'PROTOCOL-003',
    title: 'Growth Hacker',
    department: 'Growth Reactor',
    location: 'Remote',
    type: 'Full-time',
    experience: '3+ years',
    salary: '$80k - $120k + Commission',
    status: 'open',
    description: 'Break the algorithms. Drive ROI. Work directly under the CSO to dominate market segments.',
    requirements: [
      'Proven track record in growth marketing',
      'Expert in SEO/SEM, PPC, social media',
      'Analytical mindset with data skills',
      'Experience with marketing automation',
      'Strong copywriting skills'
    ],
    responsibilities: [
      'Develop growth strategies',
      'Execute multi-channel campaigns',
      'Analyze performance metrics',
      'Optimize conversion funnels',
      'Stay ahead of marketing trends'
    ],
    posted: '2024-01-05',
    deadline: '2024-02-20'
  },
  {
    id: 'PROTOCOL-004',
    title: 'DevOps Engineer',
    department: 'The Backbone',
    location: 'HQ',
    type: 'Full-time',
    experience: '4+ years',
    salary: '$100k - $150k',
    status: 'closed',
    description: 'Build and maintain our cloud infrastructure. Ensure 99.99% uptime for global systems.',
    requirements: [
      'Expert in Docker, Kubernetes, Terraform',
      'Experience with AWS/GCP/Azure',
      'CI/CD pipeline expertise',
      'Monitoring and logging tools',
      'Security best practices'
    ],
    responsibilities: [
      'Manage cloud infrastructure',
      'Implement CI/CD pipelines',
      'Monitor system performance',
      'Ensure security compliance',
      'Disaster recovery planning'
    ],
    posted: '2023-12-20',
    deadline: '2024-01-31'
  },
  {
    id: 'PROTOCOL-005',
    title: 'UI/UX Designer',
    department: 'Digital Cortex',
    location: 'Remote',
    type: 'Contract',
    experience: '3+ years',
    salary: '$60 - $100/hour',
    status: 'open',
    description: 'Design the interfaces of tomorrow. Create experiences that feel like reading the user\'s mind.',
    requirements: [
      'Strong portfolio of UI/UX work',
      'Expert in Figma, Adobe Creative Suite',
      'Understanding of design systems',
      'Experience with prototyping',
      'Knowledge of front-end technologies'
    ],
    responsibilities: [
      'Design user interfaces',
      'Create wireframes and prototypes',
      'Conduct user research',
      'Collaborate with developers',
      'Maintain design system'
    ],
    posted: '2024-01-12',
    deadline: '2024-02-29'
  }
]

export const departments = [
  'All Departments',
  'Growth Reactor',
  'Digital Cortex', 
  'Synthetic Intelligence',
  'The Backbone',
  'Operations',
  'Strategy'
]

export const jobTypes = [
  'All Types',
  'Full-time',
  'Part-time',
  'Contract',
  'Internship'
]

export const locations = [
  'All Locations',
  'HQ',
  'Remote',
  'Hybrid',
  'Global'
]